import { AuthGuard } from './../authentication/guards/auth.guard';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ResumesListComponent } from './components/resumes-list/resumes-list.component';
import { CreateResumeComponent } from './components/create-resume/create-resume.component';

const routes: Routes = [
  {
    path: 'resume-portal',
    canActivate: [AuthGuard],
    children: [
      {
        path: 'all-resumes',
        component: ResumesListComponent,
      },
      {
        path: 'create-resume',
        component: CreateResumeComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ResumeRoutingModule {}
